import { useAsync } from 'react-async-hook';
import useConstant from 'use-constant';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { useState } from 'react';

import axios from 'packs/axios';

const approvalCreditLimit = async url =>
  url === null
    ? undefined
    : await axios
        .get(url)
        .then(({ data }) => ({ success: true, data }))
        .catch(({ response }) => {
          if (response) {
            return { success: false, data: response };
          } else {
            return {
              success: false,
              data: {
                data: { message: 'Network error' },
                status: 500,
                statusText: 'Network error',
              },
            };
          }
        });

const useApprovalCreditLimit = () => {
  const [url, setUrl] = useState(null);

  const debounceUserCreditLimit = useConstant(() =>
    AwesomeDebouncePromise(approvalCreditLimit, 300),
  );

  const response = useAsync(async () => debounceUserCreditLimit(url), [url]);

  return {
    response,
    setUrl,
  };
};

export default useApprovalCreditLimit;
